import { useAuth } from '@/app/providers/AuthProvider';

/**
 * Ritorna l'id dell'utente loggato. Preferisce `user.id` (popolato dal login response BE);
 * fallback sul claim `userId` (BE v1.9, presente in token e refresh) e infine su
 * `decoded.sub` per token legacy.
 */
export function useCurrentUserId(): string {
  const { user, decoded } = useAuth();
  return user?.id ?? decoded?.userId ?? decoded?.sub ?? '';
}
